<template>
  <VCard class="detail-products-wrapper">
    <VBlock :padding="[10, 15, 25, 15]" :direction="Direction.column">
      <!-- TODO items => products($.items) -->
      <VBlock
        v-for="(product, index) in orderDetailProducts"
        class="product"
        :key="index"
        :padding="[15, 0, 15, 0]"
        :sort="Sort.left_top"
        :direction="Direction.column"
      >
        <VBlock>
          <VBlock class="left" :direction="Direction.column" :padding="[10, 15, 0, 0]" :sort="Sort.left_top">
            <VSpan class="title" :text="`${product.name}`" :size="16" :weight="TextWeight.bold" :spacing="-0.38" />

            <VBlock class="items" :direction="Direction.column" :margin="[10, 0, 10, 0]" :sort="Sort.left_top">
              <VBlock v-for="(item, index) in product.items" class="item" :key="`item${index}`" :sort="Sort.left_top">
                <VBullet class="bullet" />
                <VSpan
                  class="text"
                  v-if="product.isFixedType"
                  :text="`${item.name} ${item.quantity}개`"
                  :color="TextColor.gray2"
                  :size="14"
                />
                <VSpan
                  class="text"
                  v-else
                  :text="`${item.name} ${product.isBundle ? product.bundle.quantity : item.quantity}개 (${
                    product.isBundle ? product.bundle.price : item.unitPrice
                  }원)`"
                  :type="TextType.Number"
                  :color="TextColor.gray2"
                  :size="14"
                />
              </VBlock>
            </VBlock>

            <VSpan :text="`${product.salePrice}원`" :type="TextType.Number" :size="16" />
          </VBlock>
          <VBlock class="right">
            <VA
              :onClick="
                () => {
                  onMoveProduct(product)
                }
              "
            >
              <VImage :src="product.imageUrl" :width="60" :height="60" />
            </VA>
          </VBlock>
        </VBlock>
        <VBlock
          v-if="product.options.length > 0"
          :direction="Direction.column"
          class="free-gift-wrapper"
          :margin="[10, 0, 0, 0]"
          :padding="[0, 0, 5, 0]"
        >
          <VBlock class="underline" :margin="[0, 0, 15, 0]" />
          <VBlock
            class="free-gift"
            v-for="(option, index) in product.options"
            :key="index"
            :margin="index < product.options.length - 1 ? [0, 0, 4] : [0]"
          >
            <VBlock class="dot-wrapper">
              <div class="dot"></div>
            </VBlock>
            <VP
              class="text"
              :text="`${option.name} ${option.quantity}개`"
              :size="14"
              :spacing="-0.35"
              :color="TextColor.gray2"
            />
          </VBlock>
        </VBlock>
      </VBlock>
    </VBlock>
  </VCard>
</template>

<script>
import VCard from '../../molecules/VCard'
import VBlock, { Direction, Sort } from '../../molecules/VBlock'
import VSpan, { TextColor, TextWeight, TextType } from '../../atoms/VSpan'
import VA from '../../molecules/VA'
import VBullet from '../../atoms/VBullet'
import VImage from '@/presentationals/v2/components/layouts/atoms/VImage'
import VP from '../../atoms/VP'

export default {
  name: 'OrderDetailProducts',
  components: { VBullet, VSpan, VBlock, VCard, VA, VImage, VP },
  props: {
    orderDetailProducts: {
      type: Array,
      required: true,
      validator: (e) => e instanceof Object // src/v2-models/MyOrder/OrderDetailItem.js:1
    },
    onMoveProduct: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      Direction,
      Sort,
      TextColor,
      TextWeight,
      TextType
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.detail-products-wrapper {
  width: 100%;
  height: auto;

  & .product {
    border-bottom: 1px solid $light-gray-8;

    & .left {
      width: calc(100% - 60px);

      & .title {
        line-height: 1.1;
      }

      & .items {
        width: 100%;

        & .item {
          position: relative;
          width: 100%;

          .text {
            width: 100%;
            margin-left: 8px;
          }

          .bullet {
            top: 7px;
          }
        }
      }
    }

    & .right {
      width: 60px;
      height: 60px;
      overflow: hidden;
      border-radius: 4px;
      border: 1px solid $light-gray-4;
    }

    /* .product-title-name {
      width: calc(100% - 85px);
    }

    .price-wrapper {
      width: 85px !important;
      .price {
        // width: 85px !important;
        white-space: nowrap;
      }
    }

    .product-item {
      position: relative;
      width: calc(100% - 85px);

      .text {
        margin-left: 8px;
      }

      .bullet {
        top: 7px;
      }
    } */
  }

  & .free-gift-wrapper {
    & .underline {
      width: 100%;
      height: 1px;
      background-image: linear-gradient(to right, $light-gray-4 20%, rgba(255, 255, 255, 0) 0%);
      background-position: bottom;
      background-size: 5px 2px; /*점선 간격 수정*/
      background-repeat: repeat-x;
    }
    // border-top: dotted $light-gray-4;
    // border-width: 3px;

    & .free-gift {
      width: 100%;
      height: auto;

      & .dot-wrapper {
        width: 3px;
        height: auto;
        margin-right: 4px;

        & .dot {
          width: 3px;
          height: 3px;
          border-radius: 3px;
          background-color: $gray-2;
        }
      }

      & .text {
        width: calc(100% - 0px);
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
        white-space: nowrap;
      }
    }
  }
}
</style>
